import React, { Component } from 'react';
import classNames from 'classnames';
import { Tooltip, Popconfirm, Dropdown } from 'antd';
import PropTypes from 'prop-types';

import { COLORS } from '../../../../../../../../data/config/constants';
import { IconEdit, IconLock, IconDelete, IconAdd, IconRight } from '../../../../../../../../data/assets/icons';

class EntityNode extends Component {
    render() {
        const { removeNode, connectLink, editEntityNode, createEntityNode, createWorkflowNode, model } = this.props;

        if (model) {
            return (
                <div className={classNames("ori-relative ori-animated ori-zoom-in ori-pad-5 ori-bg-white  ori-border-radius-4", { "ori-border-primary ori-box-shadow-primary": model.start, "ori-border-aquamarine ori-box-shadow-aquamarine": !model.start && !model.end, "ori-border-danger ori-box-shadow-danger": model.end })} style={{ width: "200px", minHeight: "100px" }}>
                    <div className="ori-absolute ori-align-left-full ori-align-bottom ori-l-pad-5" style={{ minWidth: '75px' }}>
                        <Dropdown overlay={<NodeTypeList createEntityNode={() => createEntityNode(model)} createWorkflowNode={() => createWorkflowNode(model)} />} placement="topLeft" trigger={['click']}>
                            <div className="ori-flex-row ori-cursor-ptr" >
                                <Tooltip overlayClassName="ori-tooltip-tag" placement="left" title="Add Node">
                                    <IconAdd size={17} style={{ color: model.start ? COLORS.primary : (model.end ? COLORS.danger : COLORS.aquamarine) }} />
                                </Tooltip>
                                <span className="ori-l-pad-3 ori-font-xs">&nbsp;Node</span>
                            </div>
                        </Dropdown>
                        <div className="ori-flex-row ori-cursor-ptr " onClick={() => connectLink({ currently: true, from: model.id })}>
                            <Tooltip overlayClassName="ori-tooltip-tag" placement="left" title="Connect Link">
                                <IconAdd size={17} style={{ color: model.start ? COLORS.primary : (model.end ? COLORS.danger : COLORS.aquamarine) }} />
                            </Tooltip>
                            <span className="ori-l-pad-3 ori-font-xs">&nbsp;Link</span>
                        </div>
                    </div>
                    <div className="ori-relative ori-r-pad-60 ori-b-pad-5">
                        <div className="ori-flex" style={{ minHeight: '22px' }}>
                            {
                                model && model.nodeId &&
                                <div className="ori-font-xs ori-lr-pad-10 ori-font-white ori-border-radius-10" style={{ backgroundColor: model.start ? COLORS.primary : (model.end ? COLORS.danger : COLORS.aquamarine), height: '20px', lineHeight: '20px' }}>
                                    <span>NID {model.nodeId}</span>
                                </div>
                            }
                        </div>
                        <div className="ori-absolute ori-align-top-neg-5 ori-align-right ori-flex-row">
                            {
                                model && model.auth_required &&
                                <div className="ori-cursor-ptr ori-pad-3" >
                                    <Tooltip overlayClassName="ori-tooltip-tag" placement="top" title="Auth Lock">
                                        <IconLock size={17} className="ori-font-light" />
                                    </Tooltip>
                                </div>
                            }
                            {
                                model && model.nodeId &&
                                <div className="ori-cursor-ptr ori-pad-3" onClick={() => { editEntityNode(model) }}>
                                    <Tooltip overlayClassName="ori-tooltip-tag" placement="top" title="Edit Node">
                                        <IconEdit size={14} className="ori-font-light" />
                                    </Tooltip>
                                </div>
                            }
                            <Popconfirm placement="top" title="Are you sure delete this Entity?" okText='Yes' cancelText='No' onConfirm={() => removeNode(model.id)}>
                                <div className="ori-cursor-ptr ori-pad-3">
                                    <Tooltip overlayClassName="ori-tooltip-tag" placement="top" title="Delete Node">
                                        <IconDelete size={16} className="ori-font-light" />
                                    </Tooltip>
                                </div>
                            </Popconfirm>
                        </div>
                    </div>
                    <div className="ori-block-text-overflow-dotted ori-dotted-after-xs-3">
                        <p className="ori-font-xs ori-capitalize-first ori-text-left ori-font-bold">{model.name ? model.name : "name is missing"}</p>
                    </div>
                    {
                        model.variable &&
                        <div className="ori-flex">
                            <div className="ori-lr-pad-10 ori-font-xxs ori-capitalize ori-text-overflow-dotted ori-font-white ori-tb-pad-1 ori-border-radius-10" style={{ backgroundColor: model.start ? COLORS.primary : (model.end ? COLORS.danger : COLORS.aquamarine), maxWidth: '85%' }}>
                                <span>{model.variable}</span>
                            </div>
                        </div>
                    }
                </div>
            );
        } else {
            return null;
        }
    }
}

const NodeTypeList = (props) => {
    const { createWorkflowNode, createEntityNode } = props;

    return (
        <ul className="ori-bg-white ori-border-radius-4 ori-box-shadow-light ori-no-pad ori-list-style-type-none ori-overflow-hidden" style={{ minWidth: '120px' }}>
            <li className="ori-l-pad-15 ori-tb-pad-5 ori-bg-white-hover-primary-light ori-flex-row ori-flex-jsb ori-cursor-ptr" onClick={createEntityNode}>
                <div>Entity</div>
                <div className="ori-lr-pad-5">
                    <IconRight size={16} />
                </div>
            </li>
            <li className="ori-l-pad-15 ori-tb-pad-5 ori-bg-white-hover-primary-light ori-flex-row ori-flex-jsb ori-cursor-ptr " onClick={createWorkflowNode}>
                <div >Workflow</div>
                <div className="ori-lr-pad-5">
                    <IconRight size={16} />
                </div>
            </li>
        </ul>
    );
}

NodeTypeList.propTypes = {
    createWorkflowNode: PropTypes.func,
    createEntityNode: PropTypes.func,
};

EntityNode.propTypes = {
    model: PropTypes.object,
    editEntityNode: PropTypes.func,
    removeNode: PropTypes.func,
    connectLink: PropTypes.func,
    createWorkflowNode: PropTypes.func,
    createEntityNode: PropTypes.func,
};

export default EntityNode;


// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/workflows/workflowdiagram/flowdiagram/entitynode/index.js